// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__10Tbp","title":"Info_title__30kQz","selects":"Info_selects__3HOBU","requiredAsterisk":"Info_requiredAsterisk__6xElt"};